import { processDocket } from './processDocket';
import { processDocketItem } from './processDocketItem';
import { Docket, DocketEventInput, DOCKET_ACTION } from '@oolio-group/domain';

export {
  shouldAutoBumpDocket,
  getAutoBumpStatus,
  autoBumpAttemptGuard,
} from './autoBump';
export { submitAutoBumpBatch } from './submitAutoBumpBatch';
export { createAttemptGuard } from './actionAttemptGuard';
export type { AttemptGuard } from './actionAttemptGuard';

export type ComputeNextState = (
  event: DocketEventInput,
  prevState?: Docket,
) => Docket;

//TODO to handle the nay type for computation of docket as well
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const eventHandlerMap: { [action: string]: any } = {
  [DOCKET_ACTION.DOCKET_CREATE]: processDocket,
  [DOCKET_ACTION.DOCKET_CREATE_ITEM]: processDocketItem,
};

export const moveDocketEventFirst = (events: DocketEventInput[]) => {
  if (events[0].action == 'DOCKET_CREATE') return events;
  const indexOfCreateDock = events.findIndex(
    eve => eve?.action == 'DOCKET_CREATE',
  );
  if (!indexOfCreateDock) return events;
  events.unshift(events.splice(indexOfCreateDock, 1)[0]);
  return events;
};

export const computeDocket = (
  events: DocketEventInput[],
  prevState: Docket,
) => {
  if (!events?.length) return {} as Docket;
  const processedEvents = moveDocketEventFirst(events);
  return processedEvents.reduce<Docket>((state, event) => {
    const nextState = eventHandlerMap[event.action];
    return nextState(event, state);
  }, prevState);
};
